// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar__OETvQ","withBorder":"withBorder__2t3BF"};